import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Countdown } from './Shared';
const kitItems = [{
  label: '12 Tomos digitales completos',
  value: '$47'
}, {
  label: '6 Bonos exclusivos',
  value: '$114'
}];
export const Pricing = () => {
  const checkoutUrl = 'https://pilates360.impultienda.ar/checkout';
  return <section id="precio" className="py-16 sm:py-20 bg-white scroll-mt-10" data-id="element-95">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-96">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-97">
          <h2 className="flex items-center justify-center gap-3 text-4xl sm:text-5xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-98">
            <span aria-hidden="true" data-id="element-99">🏆</span> Oferta Especial de Lanzamiento
          </h2>
          <div className="mb-4" data-id="element-100">
            <Countdown data-id="element-101" />
          </div>
          <p className="text-brand-terracotta font-medium text-sm" data-id="element-102">
            🔴 El precio sube cuando termina el contador
          </p>
        </div>

        {/* Kit Card */}
        <div className="relative bg-white rounded-3xl border-2 border-brand-sand shadow-xl px-6 sm:px-10 pt-10 pb-8 mt-8" data-id="element-103">
          {/* Overlapping Pill */}
          <div className="absolute -top-5 left-1/2 -translate-x-1/2" data-id="element-104">
            <span className="inline-block bg-brand-terracotta text-white text-xs sm:text-sm font-bold tracking-wide uppercase px-6 py-2.5 rounded-full shadow-md whitespace-nowrap" data-id="element-105">
              Contenido del Kit:
            </span>
          </div>

          {/* Line Items */}
          <div className="divide-y divide-brand-sand mb-6" data-id="element-106">
            {kitItems.map((item, i) => <div key={i} className="flex items-center justify-between py-4" data-id="element-107">
                <span className="text-brand-charcoal font-semibold text-base sm:text-lg" data-id="element-108">
                  {item.label}
                </span>
                <span className="text-brand-terracotta font-bold text-base sm:text-lg line-through" data-id="element-109">
                  {item.value}
                </span>
              </div>)}
          </div>

          {/* Total */}
          <div className="flex items-center justify-between mb-8" data-id="element-110">
            <span className="text-brand-charcoal font-serif font-bold text-lg sm:text-xl uppercase tracking-wide" data-id="element-111">
              Valor Total:
            </span>
            <span className="text-brand-terracotta font-bold text-lg sm:text-xl line-through" data-id="element-112">
              $161 USD
            </span>
          </div>

          {/* Big Price */}
          <div className="text-center mb-8" data-id="element-113">
            <div className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-114">
              <span className="text-4xl sm:text-5xl" aria-hidden="true" data-id="element-115">
                🏆
              </span>
              <span className="font-serif font-bold text-brand-terracotta text-5xl sm:text-7xl leading-none" data-id="element-116">
                $19 USD
              </span>
            </div>
            <div className="text-brand-terracotta/70 font-bold text-lg sm:text-xl line-through mt-2" data-id="element-117">
              $161 USD
            </div>
          </div>

          {/* Blinking CTA */}
          <motion.a href={checkoutUrl} target="_blank" rel="noopener noreferrer" animate={{
          scale: [1, 1.025, 1],
          boxShadow: ['0 10px 25px -5px rgba(178, 106, 120, 0.35)', '0 18px 40px -5px rgba(178, 106, 120, 0.65)', '0 10px 25px -5px rgba(178, 106, 120, 0.35)']
        }} transition={{
          duration: 1.4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="block w-full bg-brand-terracotta hover:bg-brand-terracotta-dark text-white text-lg sm:text-2xl font-bold py-5 px-6 rounded-full text-center transition-colors" data-id="element-118">
            QUIERO EL KIT PILATES 360
          </motion.a>

          {/* Trust Line */}
          <div className="mt-6 flex flex-wrap justify-center items-center gap-x-2 gap-y-1 text-xs sm:text-sm font-medium text-gray-500 text-center" data-id="element-119">
            <span data-id="element-120">Descarga inmediata</span>
            <span className="text-gray-300" data-id="element-121">·</span>
            <span data-id="element-122">Pago único</span>
            <span className="text-gray-300" data-id="element-123">·</span>
            <span data-id="element-124">Acceso de por vida</span>
            <span className="text-gray-300" data-id="element-125">·</span>
            <span data-id="element-126">7 días de garantía</span>
          </div>

          <p className="text-center text-gray-400 text-xs mt-4" data-id="element-127">
            💱 El pago se procesará en la moneda de tu país
          </p>
        </div>
      </div>

      {/* Comparison Table */}
      <div className="bg-brand-cream mt-20 pt-20 pb-4" data-id="element-128">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129">
          <div data-id="element-130">
            <h3 className="text-3xl font-serif font-bold text-brand-charcoal mb-10 text-center" data-id="element-131">
              ¿Cuánto cuesta NO tenerlo?
            </h3>
            <div className="bg-white rounded-2xl shadow-lg border border-brand-sand overflow-hidden" data-id="element-132">
              <div className="grid grid-cols-2 bg-brand-charcoal text-white p-6" data-id="element-133">
                <div className="font-bold text-lg text-center" data-id="element-134">
                  Sin PILATES 360
                </div>
                <div className="font-bold text-lg text-center text-brand-gold" data-id="element-135">
                  Con PILATES 360
                </div>
              </div>
              <div className="divide-y divide-brand-sand" data-id="element-136">
                {[['Horas planificando desde cero cada semana', '5 minutos. Todo listo.'], ['Sesiones improvisadas sin progresión real', '+150 sesiones detalladas por nivel'], ['Grupos sin sistema claro', 'Estructura clara para cada nivel'], ['Siempre los mismos ejercicios', '100 variaciones listas para usar'], ['Miedo a que un alumno se lesione', 'Checklist de seguridad incluido'], ['Terminar cada clase agotada mentalmente', 'Llegas con todo resuelto'], ['Sin poder justificar un aumento de precio', 'Sistema documentado y profesional']].map((row, i) => <div key={i} className="grid grid-cols-2 p-6 hover:bg-brand-cream transition-colors" data-id="element-137">
                    <div className="text-gray-600 pr-4" data-id="element-138">{row[0]}</div>
                    <div className="text-brand-charcoal font-semibold pl-4 border-l border-brand-sand flex items-center gap-3" data-id="element-139">
                      <Check className="text-green-500 flex-shrink-0" size={20} data-id="element-140" />{' '}
                      {row[1]}
                    </div>
                  </div>)}
              </div>
            </div>
            <p className="text-center text-xl font-serif font-bold text-brand-charcoal mt-8" data-id="element-141">
              El lunes puedes improvisar o entrar con todo resuelto. Tú decides.
            </p>
          </div>
        </div>
      </div>
    </section>;
};